export enum IntegrationType {
    Pipedrive = 'pipedrive',
    OpenAi = 'openai',
    Moskit = 'moskit',
}
